/* eslint-disable no-var */
/* eslint-disable import/no-mutable-exports */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */
// **********************************************************************
// This file was generated by a TAF parser!
// TAF version 2.1.7.7
// Generated from `WalletServant.jce'
// **********************************************************************
import { Taf } from '@huyafed/taf-network';
var HYPAY = HYPAY || {};


HYPAY.TransferNotifyOrderObj = function () {
  this.appOrderId = '';
  this.userId = '';
  this.userAcctName = '';
  this.amount = 0;
  this.currencyCode = '';
  this.statusCode = '';
  this.statusMsg = '';
  this.thirdOrderNo = '';
  this.thirdOrderTime = 0;
};
HYPAY.TransferNotifyOrderObj.prototype._clone = function () {
  return new HYPAY.TransferNotifyOrderObj();
}
HYPAY.TransferNotifyOrderObj.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HYPAY.TransferNotifyOrderObj.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HYPAY.TransferNotifyOrderObj.prototype.writeTo = function (os) {
  os.writeString(0, this.appOrderId);
  os.writeString(1, this.userId);
  os.writeString(2, this.userAcctName);
  os.writeDouble(3, this.amount);
  os.writeString(4, this.currencyCode);
  os.writeString(5, this.statusCode);
  os.writeString(6, this.statusMsg);
  os.writeString(7, this.thirdOrderNo);
  os.writeInt64(8, this.thirdOrderTime);
};

HYPAY.TransferNotifyOrderObj.prototype.readFrom = function (is) {
  this.appOrderId = is.readString(0, true, this.appOrderId);
  this.userId = is.readString(1, true, this.userId);
  this.userAcctName = is.readString(2, false, this.userAcctName);
  this.amount = is.readDouble(3, true, this.amount);
  this.currencyCode = is.readString(4, true, this.currencyCode);
  this.statusCode = is.readString(5, false, this.statusCode);
  this.statusMsg = is.readString(6, false, this.statusMsg);
  this.thirdOrderNo = is.readString(7, false, this.thirdOrderNo);
  this.thirdOrderTime = is.readInt64(8, false, this.thirdOrderTime);
};

HYPAY.TransferNotifyObj = function () {
  this.appBatchId = '';
  this.appOrderTime = 0;
  this.chId = '';
  this.payMethod = '';
  this.batchNum = 0;
  this.totalAmount = 0;
  this.transOrderList = new Taf.Vector(new HYPAY.TransferNotifyOrderObj());
};
HYPAY.TransferNotifyObj.prototype._clone = function () {
  return new HYPAY.TransferNotifyObj();
}
HYPAY.TransferNotifyObj.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HYPAY.TransferNotifyObj.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HYPAY.TransferNotifyObj.prototype.writeTo = function (os) {
  os.writeString(0, this.appBatchId);
  os.writeInt64(1, this.appOrderTime);
  os.writeString(2, this.chId);
  os.writeString(3, this.payMethod);
  os.writeInt32(4, this.batchNum);
  os.writeDouble(5, this.totalAmount);
  os.writeVector(6, this.transOrderList);
};

HYPAY.TransferNotifyObj.prototype.readFrom = function (is) {
  this.appBatchId = is.readString(0, true, this.appBatchId);
  this.appOrderTime = is.readInt64(1, false, this.appOrderTime);
  this.chId = is.readString(2, true, this.chId);
  this.payMethod = is.readString(3, true, this.payMethod);
  this.batchNum = is.readInt32(4, true, this.batchNum);
  this.totalAmount = is.readDouble(5, true, this.totalAmount);
  this.transOrderList = is.readVector(6, true, this.transOrderList);
};

HYPAY.TransferNotifyReq = function () {
  this.appId = '';
  this.notifyData = new HYPAY.TransferNotifyObj();
  this.sign = '';
};
HYPAY.TransferNotifyReq.prototype._clone = function () {
  return new HYPAY.TransferNotifyReq();
}
HYPAY.TransferNotifyReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HYPAY.TransferNotifyReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HYPAY.TransferNotifyReq.prototype.writeTo = function (os) {
  os.writeString(0, this.appId);
  os.writeStruct(1, this.notifyData);
  os.writeString(2, this.sign);
};

HYPAY.TransferNotifyReq.prototype.readFrom = function (is) {
  this.appId = is.readString(0, true, this.appId);
  this.notifyData = is.readStruct(1, true, this.notifyData);
  this.sign = is.readString(2, false, this.sign);
};

HYPAY.CommRsp = function () {
  this.statusCode = '';
  this.statusMsg = '';
  this.data = '';
};
HYPAY.CommRsp.prototype._clone = function () {
  return new HYPAY.CommRsp();
}
HYPAY.CommRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HYPAY.CommRsp.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HYPAY.CommRsp.prototype.writeTo = function (os) {
  os.writeString(0, this.statusCode);
  os.writeString(1, this.statusMsg);
  os.writeString(2, this.data);
};

HYPAY.CommRsp.prototype.readFrom = function (is) {
  this.statusCode = is.readString(0, true, this.statusCode);
  this.statusMsg = is.readString(1, true, this.statusMsg);
  this.data = is.readString(2, false, this.data);
};

var HUYA = HUYA || {};


HUYA.UserId = function () {
  this.lUid = 0;
  this.sGuid = '';
  this.sToken = '';
  this.sHuYaUA = '';
  this.sCookie = '';
  this.iTokenType = 0;
  this.sDeviceInfo = '';
};
HUYA.UserId.prototype._clone = function () {
  return new HUYA.UserId();
}
HUYA.UserId.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.UserId.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.UserId.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeString(1, this.sGuid);
  os.writeString(2, this.sToken);
  os.writeString(3, this.sHuYaUA);
  os.writeString(4, this.sCookie);
  os.writeInt32(5, this.iTokenType);
  os.writeString(6, this.sDeviceInfo);
};

HUYA.UserId.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sGuid = is.readString(1, false, this.sGuid);
  this.sToken = is.readString(2, false, this.sToken);
  this.sHuYaUA = is.readString(3, false, this.sHuYaUA);
  this.sCookie = is.readString(4, false, this.sCookie);
  this.iTokenType = is.readInt32(5, false, this.iTokenType);
  this.sDeviceInfo = is.readString(6, false, this.sDeviceInfo);
};


HUYA.EWalletRetCode =
{
  EWRC_SYSTEMERR: -1,
  EWRC_SUCCESS: 0,
  EWRC_REORDER: 1,
  EWRC_PARAM_ERROR: 10,
  EWRC_BALANCE_INSUFFICIENT: 20,
  EWRC_QUOTA_LIMIT: 30,
  EWRC_BLACKUSER: 40,
  EWRC_NEED_VERIFY_CODE: 41,
  EWRC_NEED_MSG_VERIFY: 42,
  EWRC_NEED_VERIFY_SLIDER: 43,
  EWRC_NEED_REAL_NAME: 60,
  EWRC_MULTI_REAL_NAME: 61,
  EWRC_WECHAT_UNAUTH: 70,
};

HUYA.EWalletOpType =
{
  EWOPT_TOPUP: 1,
  EWOPT_WITHDRAW: 2,
};

HUYA.CheckBalanceReq = function () {
  this.tId = new HUYA.UserId();
};
HUYA.CheckBalanceReq.prototype._clone = function () {
  return new HUYA.CheckBalanceReq();
}
HUYA.CheckBalanceReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.CheckBalanceReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.CheckBalanceReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
};

HUYA.CheckBalanceReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
};

HUYA.CheckBalanceRsp = function () {
  this.iRetCode = 0;
  this.lBalance = 0;
  this.iFirstWithdraw = 0;
  this.lFrozenBalance = 0;
};
HUYA.CheckBalanceRsp.prototype._clone = function () {
  return new HUYA.CheckBalanceRsp();
}
HUYA.CheckBalanceRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.CheckBalanceRsp.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.CheckBalanceRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iRetCode);
  os.writeInt64(1, this.lBalance);
  os.writeInt32(3, this.iFirstWithdraw);
  os.writeInt64(4, this.lFrozenBalance);
};

HUYA.CheckBalanceRsp.prototype.readFrom = function (is) {
  this.iRetCode = is.readInt32(0, false, this.iRetCode);
  this.lBalance = is.readInt64(1, false, this.lBalance);
  this.iFirstWithdraw = is.readInt32(3, false, this.iFirstWithdraw);
  this.lFrozenBalance = is.readInt64(4, false, this.lFrozenBalance);
};

HUYA.GetBusinessBalanceReq = function () {
  this.tId = new HUYA.UserId();
  this.sAppId = '';
};
HUYA.GetBusinessBalanceReq.prototype._clone = function () {
  return new HUYA.GetBusinessBalanceReq();
}
HUYA.GetBusinessBalanceReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.GetBusinessBalanceReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.GetBusinessBalanceReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeString(1, this.sAppId);
};

HUYA.GetBusinessBalanceReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.sAppId = is.readString(1, false, this.sAppId);
};

HUYA.GetBusinessBalanceRsp = function () {
  this.iRetCode = 0;
  this.lBalance = 0;
  this.lBusiCumulaAmount = 0;
  this.iFirstWithdraw = 0;
};
HUYA.GetBusinessBalanceRsp.prototype._clone = function () {
  return new HUYA.GetBusinessBalanceRsp();
}
HUYA.GetBusinessBalanceRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.GetBusinessBalanceRsp.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.GetBusinessBalanceRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iRetCode);
  os.writeInt64(1, this.lBalance);
  os.writeInt64(2, this.lBusiCumulaAmount);
  os.writeInt32(3, this.iFirstWithdraw);
};

HUYA.GetBusinessBalanceRsp.prototype.readFrom = function (is) {
  this.iRetCode = is.readInt32(0, false, this.iRetCode);
  this.lBalance = is.readInt64(1, false, this.lBalance);
  this.lBusiCumulaAmount = is.readInt64(2, false, this.lBusiCumulaAmount);
  this.iFirstWithdraw = is.readInt32(3, false, this.iFirstWithdraw);
};

HUYA.BatchGetBusinessBalanceReq = function () {
  this.tId = new HUYA.UserId();
  this.vAppId = new Taf.Vector(new Taf.STRING());
};
HUYA.BatchGetBusinessBalanceReq.prototype._clone = function () {
  return new HUYA.BatchGetBusinessBalanceReq();
}
HUYA.BatchGetBusinessBalanceReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.BatchGetBusinessBalanceReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.BatchGetBusinessBalanceReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeVector(1, this.vAppId);
};

HUYA.BatchGetBusinessBalanceReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.vAppId = is.readVector(1, false, this.vAppId);
};

HUYA.BatchGetBusinessBalanceRsp = function () {
  this.iRetCode = 0;
  this.lBalance = 0;
  this.mBusiCumulaValiAmount = new Taf.Map(new Taf.STRING(), new Taf.INT64());
};
HUYA.BatchGetBusinessBalanceRsp.prototype._clone = function () {
  return new HUYA.BatchGetBusinessBalanceRsp();
}
HUYA.BatchGetBusinessBalanceRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.BatchGetBusinessBalanceRsp.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.BatchGetBusinessBalanceRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iRetCode);
  os.writeInt64(1, this.lBalance);
  os.writeMap(2, this.mBusiCumulaValiAmount);
};

HUYA.BatchGetBusinessBalanceRsp.prototype.readFrom = function (is) {
  this.iRetCode = is.readInt32(0, false, this.iRetCode);
  this.lBalance = is.readInt64(1, false, this.lBalance);
  this.mBusiCumulaValiAmount = is.readMap(2, false, this.mBusiCumulaValiAmount);
};

HUYA.TopupBalanceReq = function () {
  this.tId = new HUYA.UserId();
  this.lAmount = 0;
  this.sOrderId = '';
  this.sAppId = '';
  this.iBusinessType = 0;
  this.sDesc = '';
  this.iBalancStatus = 0;
  this.lExpireTime = 0;
};
HUYA.TopupBalanceReq.prototype._clone = function () {
  return new HUYA.TopupBalanceReq();
}
HUYA.TopupBalanceReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.TopupBalanceReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.TopupBalanceReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt64(1, this.lAmount);
  os.writeString(2, this.sOrderId);
  os.writeString(3, this.sAppId);
  os.writeInt32(4, this.iBusinessType);
  os.writeString(5, this.sDesc);
  os.writeInt32(6, this.iBalancStatus);
  os.writeInt64(7, this.lExpireTime);
};

HUYA.TopupBalanceReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.lAmount = is.readInt64(1, false, this.lAmount);
  this.sOrderId = is.readString(2, false, this.sOrderId);
  this.sAppId = is.readString(3, false, this.sAppId);
  this.iBusinessType = is.readInt32(4, false, this.iBusinessType);
  this.sDesc = is.readString(5, false, this.sDesc);
  this.iBalancStatus = is.readInt32(6, false, this.iBalancStatus);
  this.lExpireTime = is.readInt64(7, false, this.lExpireTime);
};

HUYA.TopupBalanceRsp = function () {
  this.iRetCode = 0;
};
HUYA.TopupBalanceRsp.prototype._clone = function () {
  return new HUYA.TopupBalanceRsp();
}
HUYA.TopupBalanceRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.TopupBalanceRsp.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.TopupBalanceRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iRetCode);
};

HUYA.TopupBalanceRsp.prototype.readFrom = function (is) {
  this.iRetCode = is.readInt32(0, false, this.iRetCode);
};

HUYA.WithdrawalOption = function () {
  this.lQuota = 0;
  this.iStatus = 0;
  this.sDesc = '';
};
HUYA.WithdrawalOption.prototype._clone = function () {
  return new HUYA.WithdrawalOption();
}
HUYA.WithdrawalOption.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.WithdrawalOption.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.WithdrawalOption.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lQuota);
  os.writeInt32(1, this.iStatus);
  os.writeString(2, this.sDesc);
};

HUYA.WithdrawalOption.prototype.readFrom = function (is) {
  this.lQuota = is.readInt64(0, false, this.lQuota);
  this.iStatus = is.readInt32(1, false, this.iStatus);
  this.sDesc = is.readString(2, false, this.sDesc);
};

HUYA.GetWithdrawalPanelsReq = function () {
  this.tId = new HUYA.UserId();
};
HUYA.GetWithdrawalPanelsReq.prototype._clone = function () {
  return new HUYA.GetWithdrawalPanelsReq();
}
HUYA.GetWithdrawalPanelsReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.GetWithdrawalPanelsReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.GetWithdrawalPanelsReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
};

HUYA.GetWithdrawalPanelsReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
};

HUYA.GetWithdrawalPanelsRsp = function () {
  this.iRetCode = 0;
  this.lBalance = 0;
  this.iCustomizable = 0;
  this.vOption = new Taf.Vector(new HUYA.WithdrawalOption());
  this.sEarnMoreUrl = '';
  this.sWeChatNickName = '';
  this.lFrozenBalance = 0;
};
HUYA.GetWithdrawalPanelsRsp.prototype._clone = function () {
  return new HUYA.GetWithdrawalPanelsRsp();
}
HUYA.GetWithdrawalPanelsRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.GetWithdrawalPanelsRsp.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.GetWithdrawalPanelsRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iRetCode);
  os.writeInt64(1, this.lBalance);
  os.writeInt32(2, this.iCustomizable);
  os.writeVector(3, this.vOption);
  os.writeString(4, this.sEarnMoreUrl);
  os.writeString(5, this.sWeChatNickName);
  os.writeInt64(6, this.lFrozenBalance);
};

HUYA.GetWithdrawalPanelsRsp.prototype.readFrom = function (is) {
  this.iRetCode = is.readInt32(0, false, this.iRetCode);
  this.lBalance = is.readInt64(1, false, this.lBalance);
  this.iCustomizable = is.readInt32(2, false, this.iCustomizable);
  this.vOption = is.readVector(3, false, this.vOption);
  this.sEarnMoreUrl = is.readString(4, false, this.sEarnMoreUrl);
  this.sWeChatNickName = is.readString(5, false, this.sWeChatNickName);
  this.lFrozenBalance = is.readInt64(6, false, this.lFrozenBalance);
};

HUYA.WithdrawBalanceReq = function () {
  this.tId = new HUYA.UserId();
  this.lAmount = 0;
  this.sOrderId = '';
  this.iFromType = 0;
  this.sOpenId = '';
};
HUYA.WithdrawBalanceReq.prototype._clone = function () {
  return new HUYA.WithdrawBalanceReq();
}
HUYA.WithdrawBalanceReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.WithdrawBalanceReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.WithdrawBalanceReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt64(1, this.lAmount);
  os.writeString(2, this.sOrderId);
  os.writeInt32(3, this.iFromType);
  os.writeString(4, this.sOpenId);
};

HUYA.WithdrawBalanceReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.lAmount = is.readInt64(1, false, this.lAmount);
  this.sOrderId = is.readString(2, false, this.sOrderId);
  this.iFromType = is.readInt32(3, false, this.iFromType);
  this.sOpenId = is.readString(4, false, this.sOpenId);
};

HUYA.WithdrawBalanceRsp = function () {
  this.iRetCode = 0;
  this.sMessage = '';
  this.sJumpUrl = '';
};
HUYA.WithdrawBalanceRsp.prototype._clone = function () {
  return new HUYA.WithdrawBalanceRsp();
}
HUYA.WithdrawBalanceRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.WithdrawBalanceRsp.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.WithdrawBalanceRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iRetCode);
  os.writeString(1, this.sMessage);
  os.writeString(2, this.sJumpUrl);
};

HUYA.WithdrawBalanceRsp.prototype.readFrom = function (is) {
  this.iRetCode = is.readInt32(0, false, this.iRetCode);
  this.sMessage = is.readString(1, false, this.sMessage);
  this.sJumpUrl = is.readString(2, false, this.sJumpUrl);
};

HUYA.WithdrawBusiBalanceReq = function () {
  this.tId = new HUYA.UserId();
  this.lAmount = 0;
  this.sOrderId = '';
  this.iFromType = 0;
  this.sAppId = '';
};
HUYA.WithdrawBusiBalanceReq.prototype._clone = function () {
  return new HUYA.WithdrawBusiBalanceReq();
}
HUYA.WithdrawBusiBalanceReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.WithdrawBusiBalanceReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.WithdrawBusiBalanceReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt64(1, this.lAmount);
  os.writeString(2, this.sOrderId);
  os.writeInt32(3, this.iFromType);
  os.writeString(4, this.sAppId);
};

HUYA.WithdrawBusiBalanceReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.lAmount = is.readInt64(1, false, this.lAmount);
  this.sOrderId = is.readString(2, false, this.sOrderId);
  this.iFromType = is.readInt32(3, false, this.iFromType);
  this.sAppId = is.readString(4, false, this.sAppId);
};

HUYA.WithdrawBusiBalanceRsp = function () {
  this.iRetCode = 0;
  this.sMessage = '';
  this.sJumpUrl = '';
};
HUYA.WithdrawBusiBalanceRsp.prototype._clone = function () {
  return new HUYA.WithdrawBusiBalanceRsp();
}
HUYA.WithdrawBusiBalanceRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.WithdrawBusiBalanceRsp.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.WithdrawBusiBalanceRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iRetCode);
  os.writeString(1, this.sMessage);
  os.writeString(2, this.sJumpUrl);
};

HUYA.WithdrawBusiBalanceRsp.prototype.readFrom = function (is) {
  this.iRetCode = is.readInt32(0, false, this.iRetCode);
  this.sMessage = is.readString(1, false, this.sMessage);
  this.sJumpUrl = is.readString(2, false, this.sJumpUrl);
};

HUYA.BalanceOperDetail = function () {
  this.iOpType = 0;
  this.lOpTime = 0;
  this.lOpAmount = 0;
  this.sOpDesc = '';
};
HUYA.BalanceOperDetail.prototype._clone = function () {
  return new HUYA.BalanceOperDetail();
}
HUYA.BalanceOperDetail.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.BalanceOperDetail.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.BalanceOperDetail.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iOpType);
  os.writeInt64(1, this.lOpTime);
  os.writeInt64(2, this.lOpAmount);
  os.writeString(3, this.sOpDesc);
};

HUYA.BalanceOperDetail.prototype.readFrom = function (is) {
  this.iOpType = is.readInt32(0, false, this.iOpType);
  this.lOpTime = is.readInt64(1, false, this.lOpTime);
  this.lOpAmount = is.readInt64(2, false, this.lOpAmount);
  this.sOpDesc = is.readString(3, false, this.sOpDesc);
};

HUYA.GetBalanceOperDetailReq = function () {
  this.tId = new HUYA.UserId();
};
HUYA.GetBalanceOperDetailReq.prototype._clone = function () {
  return new HUYA.GetBalanceOperDetailReq();
}
HUYA.GetBalanceOperDetailReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.GetBalanceOperDetailReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.GetBalanceOperDetailReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
};

HUYA.GetBalanceOperDetailReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
};

HUYA.GetBalanceOperDetailRsp = function () {
  this.vOpInfo = new Taf.Vector(new HUYA.BalanceOperDetail());
};
HUYA.GetBalanceOperDetailRsp.prototype._clone = function () {
  return new HUYA.GetBalanceOperDetailRsp();
}
HUYA.GetBalanceOperDetailRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.GetBalanceOperDetailRsp.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.GetBalanceOperDetailRsp.prototype.writeTo = function (os) {
  os.writeVector(0, this.vOpInfo);
};

HUYA.GetBalanceOperDetailRsp.prototype.readFrom = function (is) {
  this.vOpInfo = is.readVector(0, false, this.vOpInfo);
};

HUYA.GetBalanceOrderIdReq = function () {
  this.tId = new HUYA.UserId();
};
HUYA.GetBalanceOrderIdReq.prototype._clone = function () {
  return new HUYA.GetBalanceOrderIdReq();
}
HUYA.GetBalanceOrderIdReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.GetBalanceOrderIdReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.GetBalanceOrderIdReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
};

HUYA.GetBalanceOrderIdReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
};

HUYA.GetBalanceOrderIdRsp = function () {
  this.sOrderId = '';
};
HUYA.GetBalanceOrderIdRsp.prototype._clone = function () {
  return new HUYA.GetBalanceOrderIdRsp();
}
HUYA.GetBalanceOrderIdRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.GetBalanceOrderIdRsp.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.GetBalanceOrderIdRsp.prototype.writeTo = function (os) {
  os.writeString(0, this.sOrderId);
};

HUYA.GetBalanceOrderIdRsp.prototype.readFrom = function (is) {
  this.sOrderId = is.readString(0, false, this.sOrderId);
};

HUYA.WalletUserSecureVerifyReq = function () {
  this.tId = new HUYA.UserId();
  this.iFromType = 0;
  this.sOpenId = '';
};
HUYA.WalletUserSecureVerifyReq.prototype._clone = function () {
  return new HUYA.WalletUserSecureVerifyReq();
}
HUYA.WalletUserSecureVerifyReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.WalletUserSecureVerifyReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.WalletUserSecureVerifyReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt32(1, this.iFromType);
  os.writeString(2, this.sOpenId);
};

HUYA.WalletUserSecureVerifyReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.iFromType = is.readInt32(1, false, this.iFromType);
  this.sOpenId = is.readString(2, false, this.sOpenId);
};

HUYA.WalletUserSecureVerifyRsp = function () {
  this.iRetCode = 0;
  this.sMessage = '';
  this.sJumpUrl = '';
};
HUYA.WalletUserSecureVerifyRsp.prototype._clone = function () {
  return new HUYA.WalletUserSecureVerifyRsp();
}
HUYA.WalletUserSecureVerifyRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.WalletUserSecureVerifyRsp.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.WalletUserSecureVerifyRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iRetCode);
  os.writeString(1, this.sMessage);
  os.writeString(2, this.sJumpUrl);
};

HUYA.WalletUserSecureVerifyRsp.prototype.readFrom = function (is) {
  this.iRetCode = is.readInt32(0, false, this.iRetCode);
  this.sMessage = is.readString(1, false, this.sMessage);
  this.sJumpUrl = is.readString(2, false, this.sJumpUrl);
};

HUYA.ReleaseFrozenOrderReq = function () {
  this.tId = new HUYA.UserId();
  this.sOrderId = '';
  this.iOpCode = 0;
  this.sAppId = '';
  this.sDesc = '';
};
HUYA.ReleaseFrozenOrderReq.prototype._clone = function () {
  return new HUYA.ReleaseFrozenOrderReq();
}
HUYA.ReleaseFrozenOrderReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.ReleaseFrozenOrderReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.ReleaseFrozenOrderReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeString(1, this.sOrderId);
  os.writeInt32(2, this.iOpCode);
  os.writeString(3, this.sAppId);
  os.writeString(4, this.sDesc);
};

HUYA.ReleaseFrozenOrderReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.sOrderId = is.readString(1, false, this.sOrderId);
  this.iOpCode = is.readInt32(2, false, this.iOpCode);
  this.sAppId = is.readString(3, false, this.sAppId);
  this.sDesc = is.readString(4, false, this.sDesc);
};

HUYA.ReleaseFrozenOrderRsp = function () {
  this.iRetCode = 0;
  this.sMessage = '';
};
HUYA.ReleaseFrozenOrderRsp.prototype._clone = function () {
  return new HUYA.ReleaseFrozenOrderRsp();
}
HUYA.ReleaseFrozenOrderRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.ReleaseFrozenOrderRsp.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.ReleaseFrozenOrderRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iRetCode);
  os.writeString(1, this.sMessage);
};

HUYA.ReleaseFrozenOrderRsp.prototype.readFrom = function (is) {
  this.iRetCode = is.readInt32(0, false, this.iRetCode);
  this.sMessage = is.readString(1, false, this.sMessage);
};

HUYA.BalanceTransferUser = function () {
  this.tId = new HUYA.UserId();
  this.sUserIp = '';
  this.sOpenId = '';
};
HUYA.BalanceTransferUser.prototype._clone = function () {
  return new HUYA.BalanceTransferUser();
}
HUYA.BalanceTransferUser.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.BalanceTransferUser.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.BalanceTransferUser.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeString(1, this.sUserIp);
  os.writeString(2, this.sOpenId);
};

HUYA.BalanceTransferUser.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.sUserIp = is.readString(1, false, this.sUserIp);
  this.sOpenId = is.readString(2, false, this.sOpenId);
};

HUYA.BalanceTransferApply = function () {
  this.tUserInfo = new HUYA.BalanceTransferUser();
  this.lAmount = 0;
  this.sOrderId = '';
  this.lTS = 0;
  this.iRetryCount = 0;
  this.iFromType = 0;
};
HUYA.BalanceTransferApply.prototype._clone = function () {
  return new HUYA.BalanceTransferApply();
}
HUYA.BalanceTransferApply.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.BalanceTransferApply.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.BalanceTransferApply.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tUserInfo);
  os.writeInt64(1, this.lAmount);
  os.writeString(2, this.sOrderId);
  os.writeInt64(3, this.lTS);
  os.writeInt32(4, this.iRetryCount);
  os.writeInt32(5, this.iFromType);
};

HUYA.BalanceTransferApply.prototype.readFrom = function (is) {
  this.tUserInfo = is.readStruct(0, false, this.tUserInfo);
  this.lAmount = is.readInt64(1, false, this.lAmount);
  this.sOrderId = is.readString(2, false, this.sOrderId);
  this.lTS = is.readInt64(3, false, this.lTS);
  this.iRetryCount = is.readInt32(4, false, this.iRetryCount);
  this.iFromType = is.readInt32(5, false, this.iFromType);
};

HUYA.FixBalanceOrderReq = function () {
  this.lUid = 0;
  this.iOpType = 0;
  this.sUserIp = '';
  this.lAmount = 0;
  this.sOrderId = '';
  this.sAppId = '';
  this.iBusinessType = 0;
  this.sDesc = '';
  this.lTS = 0;
  this.iRetryCount = 0;
  this.lExpireTime = 0;
};
HUYA.FixBalanceOrderReq.prototype._clone = function () {
  return new HUYA.FixBalanceOrderReq();
}
HUYA.FixBalanceOrderReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.FixBalanceOrderReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.FixBalanceOrderReq.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeInt32(1, this.iOpType);
  os.writeString(2, this.sUserIp);
  os.writeInt64(3, this.lAmount);
  os.writeString(4, this.sOrderId);
  os.writeString(5, this.sAppId);
  os.writeInt32(6, this.iBusinessType);
  os.writeString(7, this.sDesc);
  os.writeInt64(8, this.lTS);
  os.writeInt32(9, this.iRetryCount);
  os.writeInt64(10, this.lExpireTime);
};

HUYA.FixBalanceOrderReq.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.iOpType = is.readInt32(1, false, this.iOpType);
  this.sUserIp = is.readString(2, false, this.sUserIp);
  this.lAmount = is.readInt64(3, false, this.lAmount);
  this.sOrderId = is.readString(4, false, this.sOrderId);
  this.sAppId = is.readString(5, false, this.sAppId);
  this.iBusinessType = is.readInt32(6, false, this.iBusinessType);
  this.sDesc = is.readString(7, false, this.sDesc);
  this.lTS = is.readInt64(8, false, this.lTS);
  this.iRetryCount = is.readInt32(9, false, this.iRetryCount);
  this.lExpireTime = is.readInt64(10, false, this.lExpireTime);
};

HUYA.QueryAccountRestReq = function () {
  this.lUid = 0;
};
HUYA.QueryAccountRestReq.prototype._clone = function () {
  return new HUYA.QueryAccountRestReq();
}
HUYA.QueryAccountRestReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.QueryAccountRestReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.QueryAccountRestReq.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
};

HUYA.QueryAccountRestReq.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
};

HUYA.QueryAccountRestRsp = function () {
  this.iRetCode = 0;
  this.lAccountRest = 0;
};
HUYA.QueryAccountRestRsp.prototype._clone = function () {
  return new HUYA.QueryAccountRestRsp();
}
HUYA.QueryAccountRestRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
HUYA.QueryAccountRestRsp.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

HUYA.QueryAccountRestRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iRetCode);
  os.writeInt64(1, this.lAccountRest);
};

HUYA.QueryAccountRestRsp.prototype.readFrom = function (is) {
  this.iRetCode = is.readInt32(0, false, this.iRetCode);
  this.lAccountRest = is.readInt64(1, false, this.lAccountRest);
};

export default HUYA;